import { useEffect } from "react";
import { Menu, MenuItem, Grid, Box, ListItemIcon, ListItemText, Button, FormControl, InputLabel, Select, CircularProgress, Typography } from "@mui/material";
import MaterialTable from "material-table";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import SendIcon from '@mui/icons-material/Send';
import { Tooltip, IconButton } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useState } from "react";
import SelectableSearch from "../../../Base/views/SelectableSearch";
import { GetAtsCompanyAction } from "../../../../../store/ATS/Company/Action";
import { useDispatch, useSelector } from "react-redux";
import { GetAtsGenerateInvoiceCandidatesAction, GetAtsInvoiceAction, GetAtsInvoiceCandidatesAction, UpdateAtsInvoiceAction } from "../../../../../store/ATS/Invoice/Action";
import { ConvertDate, getImageSignedUrl, getUserData } from "../../../Base/helper/baseFunctions";
import ATSGeneratedInvoicePopup from "./ATSGeneratedInvoicePopup";
import AtsInvoicePdf from "./AtsInvoicePdf";
import { CSVLink } from "react-csv";
import ATSGenerateInvoicePopup from "./ATSGenerateInvoicePopup";
import Popup from "../../../Base/views/Popup";
import AtsInvoiceMail from "./AtsInvoiceMail";
import CustomToggle from "../../../Base/views/CustomToggle";
import { GetAtsGroupCompanyAction } from "../../../../../store/ATS/GroupCompany/Action";
import { useLocation } from "react-router-dom";
import history from "../../../../../history";
import { pdf } from "@react-pdf/renderer";
import CreditCardOffIcon from '@mui/icons-material/CreditCardOff';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import { toast } from "react-toastify";
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";

const ATSGenerateInvoice = () => {
    const user = getUserData();
    const [imageUrl, setImageUrl] = useState("");
    const isGroupOrgFlowTrueText = user?.grouporg_flow === true ? 'Group Organisation' : 'Client';
    const isGroupOrgFlowTrue = user?.grouporg_flow === true;
    const dispatch = useDispatch();
    const { atsCompanyData } = useSelector(state => state.AtsReducer?.AtsCompanyReducer)
    const { atsGroupCompanyData } = useSelector(
        (state) => state.AtsReducer?.AtsGroupCompanyReducer
    );
    const { letterHeadData } = useSelector(state => state?.AncillaryReducer?.LetterHeadReducer);
    const { invoiceData, generateInvoiceCandidateData, isGenerateCandidateLoading, isInvoiceLoading } = useSelector(state => state.AtsReducer?.AtsInvoiceReducer)
    const [currentData, setCurrentData] = useState({});
    const { invoiceCandidateData, isCandidateLoading } = useSelector(state => state.AtsReducer?.AtsInvoiceReducer)
    const [anchorEl, setAnchorEl] = useState(false);
    const [toggle, setToggle] = useState(false);
    const [companyData, setCompanyData] = useState({ load: false, values: [] })
    const [atsgroupUser, setAtsGroupUser] = useState({
        load: true,
        values: [],
    });
    const [showGeneratedInvoice, setShowGeneratedInvoice] = useState(false);
    const [showGenerateInvoice, setShowGenerateInvoice] = useState(false);
    const [filters, setFilters] = useState({ company_filter: "", days: 7, invoice_filter: "Not Paid" });
    const [generateCandidate, setGenerateCandidate] = useState(generateInvoiceCandidateData)
    const [candidateInvoiceData, setCandidateInvoiceData] = useState(invoiceData || [])
    const [selectedCandidates, setSelectedCandidates] = useState([])
    const [sendmail, setSendMail] = useState(false);
    const { featuresData } = useSelector(state => state?.RoleAndAccessReducer?.ATSModuleFeaturesReducer);
    const { company_logo } = useSelector(state => state?.AncillaryReducer?.LetterHeadReducer);
    const { company_config_data } = useSelector((state) => state?.AncillaryReducer?.CompanyConfigReducer);
    const location = useLocation();
    const { defaultValue } = location?.state || {};
    const headers = [
        { label: "Candidate Name", key: "first_name" },
        { label: "Job Title", key: "job_title" },
        { label: "Joined Date", key: "joined_date" },
        { label: "Billable CTC", key: "billable_ctc" },
    ];
    const [openDialog, setOpenDialog] = useState(false);

    useEffect(() => {
        toggle === true && dispatch(GetAtsInvoiceAction({ status: "Not Paid", ats_company_id: filters?.company_filter, past_days: filters?.days }))
        if (defaultValue && toggle === false) {
            const company = findCompany();
            dispatch(GetAtsGenerateInvoiceCandidatesAction({ ats_company_id: company?.[0], past_days: filters?.days }));
            setFilters({ ...filters, company_filter: company?.[0] });
            history.replace({ ...location, state: {} });
        }
        else {
            toggle === false && dispatch(GetAtsGenerateInvoiceCandidatesAction({ ats_company_id: filters?.company_filter, past_days: filters?.days }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [toggle])
    
    const findCompany = () => {
        let company;
        if (isGroupOrgFlowTrue) {
            company = atsGroupCompanyData?.filter((el) => el.ats_company_id === defaultValue)
        }
        else {
            company = atsCompanyData?.filter((el) => el.ats_company_id === defaultValue)
        }
        return company
    }
    useEffect(() => {
        isGroupOrgFlowTrue ? dispatch(GetAtsGroupCompanyAction()) : dispatch(GetAtsCompanyAction())
        getImageSignedUrl(company_logo).then((url) => {
          setImageUrl(url);
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    useEffect(() => {
        setGenerateCandidate(generateInvoiceCandidateData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [generateInvoiceCandidateData])
    useEffect(() => {
        setCandidateInvoiceData(invoiceData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [invoiceData])

    const handleDisabled = (permission) => {
        const foundPermission = featuresData?.find((item) => item.permission === permission);
        return foundPermission ? true : false;
    };
   

    const handleFilter = (event, value) => {
        if (["company_filter"].includes(event)) {
            setFilters({ ...filters, [event]: value })
            if (toggle) dispatch(GetAtsInvoiceAction({ status: "Not Paid", ats_company_id: value, past_days: filters?.days }))
            else dispatch(GetAtsGenerateInvoiceCandidatesAction({ ats_company_id: value, past_days: filters?.days }))
            setSelectedCompanyId(null);
        } else if (["invoice_filter", "days"].includes(event?.target?.name)) {
            setFilters({ ...filters, [event?.target?.name]: event?.target?.value })
            if (toggle) {
                dispatch(GetAtsInvoiceAction({
                    status: "Not Paid",
                    ats_company_id: filters?.company_filter,
                    past_days: event?.target?.name === "days" ? event?.target?.value : filters?.days
                }))
            }
            else {
                dispatch(GetAtsGenerateInvoiceCandidatesAction({ ats_company_id: filters?.company_filter, past_days: event?.target?.name === "days" ? event?.target?.value : filters?.days }))
            }
        }
    }

    const handleMoreVertIconClick = (event, rowData) => {
        setCurrentData(rowData)
        dispatch(GetAtsInvoiceCandidatesAction({ ats_invoice_id: rowData?.ats_invoice_id }))
        setAnchorEl(event.currentTarget);
    };
    const handleMoreVertIconClose = () => {
        setAnchorEl(null);
    };

    const handleEdit = () => {
        setAnchorEl(false);
    };

    const [pdfLoading, setPdfLoading] = useState(false);

    const handleDownloadPdf = async () => {                                             
        try {
            setPdfLoading(true);

            const blob = await pdf(
            <AtsInvoicePdf
                data={currentData}
                invoiceCandidateData={invoiceCandidateData}
                companylogo={imageUrl}
                letterHeadData={letterHeadData?.[0]}
                orgConfigData={company_config_data}
            />
            ).toBlob();

            const url = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = `${currentData?.ats_invoice_no}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(url);

            setAnchorEl(null);
        } catch (error) {
            console.error("Error generating PDF:", error);
        } finally {
            setPdfLoading(false);
        }
    };


    const handleSendMail = () => {
        setAnchorEl(null);
        setSendMail(true)
    }

    const handleToggle = () => {
        setToggle(true);
        setFilters({ company_filter: "", days: 7, invoice_filter: "Not Paid" }); // Clear the filters state
    };

    const handleToggleoff = () => {
        setToggle(false)
        setFilters({ company_filter: "", days: 7, invoice_filter: "Not Paid" }); // Clear the filters state
    }
    const isValidNumber = (val) => {
        return /^(\d+(\.\d+)?)$/.test(val);
    };

    const handleCellEdit = (newValue, rowData, columnDef) => {
        if (columnDef.field === "commission_percentage") {
            if (!isValidNumber(newValue)) return;
            const num = Number(newValue);

            if (num > 100) {
                toast.error("Cannot exceed 100%");
                return false;
            }

            if (num <= 0) return;
        }
        if (columnDef.field === "billable_ctc") {
            if (!isValidNumber(newValue)) return;
            const num = Number(newValue);
            if (num < 0) return;
        }
         setGenerateCandidate(prev => {
            const temp = [...prev];
            const rowIndex = rowData.tableData.id;
            temp[rowIndex] = {
                ...temp[rowIndex],
                [columnDef.field]: newValue
            };
            return temp;
        });
    }


    const handleGeneratedRowClick = (event, rowData) => {
        setCurrentData(rowData);
        dispatch(GetAtsInvoiceCandidatesAction({ ats_invoice_id: rowData?.ats_invoice_id }))
        setShowGeneratedInvoice(true);
    }


    const handleAction = (status) => {
        setCurrentData({...currentData, isEditable: true, editStatus: status});
        setShowGeneratedInvoice(true);
        setAnchorEl(null);
    }
    const handlePaidStatus = (status, editData) => {
        const date = new Date();
        const paid_date = `${date?.getFullYear()}-${date?.getMonth() + 1}-${date?.getDate()}`;
        const isCancelled = status === "Cancelled";
        const isPaid = status === "Paid";
        const paidPayload = editData || {};
        
        dispatch(UpdateAtsInvoiceAction({
            ats_invoice_id: currentData?.ats_invoice_id,
            paid_status: status,
            status: "Not Paid", // return only Not Paid invoices
            ats_company_id: +filters?.company_filter?.ats_company_id || +filters?.company_filter?.ats_grouporg_id,
            past_days: filters?.days,
            paid_date: isPaid ? (paidPayload?.paid_date || paid_date) : isCancelled ? (currentData?.paid_date || paid_date) : null,
            received_amount: isCancelled ? "0" : isPaid ? paidPayload?.received_amount : null,
            tds_amount: isCancelled ? currentData?.tds_amount : isPaid ? paidPayload?.tds_amount  : null,
            final_invoice_amount: isCancelled ? currentData?.invoice_amount : isPaid ? Math.round(paidPayload?.final_invoice_amount || 0) : null
        }));
        setOpenDialog(false);
        setShowGeneratedInvoice(false);
    }
    const hadleGenerateClick = () => {
        setShowGenerateInvoice(true)
    }
    const isEditable = !handleDisabled("invoice_generate_invoice") ? "always" : "never";
    const [selectedCompanyId, setSelectedCompanyId] = useState(null);
    const [companySelected, setCompanySelected] = useState({company_filter: ""})
    const handleSelectionChange = (rows) => {
    if (!rows.length) {
        setSelectedCompanyId(null);
        setSelectedCandidates([]);
        return;
    }
    const companyId =
        rows[0]?.ats_company_id || rows[0]?.ats_grouporg_id;
    setSelectedCompanyId(companyId);
    setSelectedCandidates(rows)
    let compData = isGroupOrgFlowTrue ? atsGroupCompanyData?.filter(res => +res?.ats_grouporg_id === +companyId) : atsCompanyData?.filter(res => +res?.ats_company_id === +companyId)
    setCompanySelected({ company_filter: compData?.[0] })
    };

    const callReset = (job_id) => {
        setSelectedCompanyId(null);
        setSelectedCandidates([]);
        setCompanySelected({ company_filter: {} })
        const filterLeftCanidate = generateCandidate?.filter((el) => !job_id?.includes(el?.candidate_job_id))
        setGenerateCandidate(filterLeftCanidate)
    }
    return (
            <Box sx={{ maxHeight: "calc(100vh - 115px)", overflowY: 'auto' }}>
                {
                    showGeneratedInvoice &&
                    <ATSGeneratedInvoicePopup
                        setShowGeneratedInvoice={setShowGeneratedInvoice}
                        currentData={currentData}
                        headers={headers}
                        companylogo={imageUrl} 
                        letterHeadData={letterHeadData?.[0]}
                        handlePaidStatus={handlePaidStatus}
                    />
                }
                {
                    showGenerateInvoice &&
                    <ATSGenerateInvoicePopup
                        setShowGenerateInvoice={setShowGenerateInvoice}
                        selectedCandidates={selectedCandidates}
                        currentData={companySelected?.company_filter}
                        showGeneratedInvoice={showGeneratedInvoice}
                        filters={filters}
                        companylogo={imageUrl} 
                        letterHeadData={letterHeadData?.[0]}
                        reset={callReset}
                    />
                }
                <Box sx={{ mb: 1, mt: 1.5 }}>
                    <Grid container columnSpacing={1}>
                        <Grid item xs={12} sm={3}>

                            {isGroupOrgFlowTrue ? (
                                <SelectableSearch
                                    isOptionEqualToValue={(option, value) =>
                                        +option.ats_grouporg_id === +value.ats_grouporg_id
                                    }
                                    label="Group Org"
                                    value={filters?.company_filter}
                                    loading={() => setAtsGroupUser({ load: false, values: atsGroupCompanyData })}
                                    fieldLabel="name"
                                    required={false}
                                    variant={"outlined"}
                                    name="company_filter"
                                    size="small"
                                    onChangeEvent={handleFilter}
                                    data={atsgroupUser}
                                />
                            ) : (
                                <SelectableSearch
                                    isOptionEqualToValue={(option, value) =>
                                        +option.ats_company_id === +value.ats_company_id
                                    }
                                    label="Client"
                                    value={filters?.company_filter}
                                    loading={() => setCompanyData({ load: false, values: atsCompanyData })}
                                    fieldLabel="name"
                                    required={false}
                                    variant={"outlined"}
                                    name="company_filter"
                                    size="small"
                                    onChangeEvent={handleFilter}
                                    data={companyData}
                                />
                            )}
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <FormControl size="small" fullWidth>
                                <InputLabel id="recruiter-type-select-label">Days</InputLabel>
                                <Select
                                    name='days'
                                    labelId="days"
                                    id="days"
                                    value={filters?.days}
                                    label="Days"
                                    onChange={handleFilter}
                                >
                                    <MenuItem value={7}>Last 7 Days</MenuItem>
                                    <MenuItem value={15}>Last 15 Days</MenuItem>
                                    <MenuItem value={30}>Last 30 Days</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        {/* <Grid item xs={12} sm={2}>
                            {
                                toggle &&
                                <FormControl size="small" fullWidth>
                                    <InputLabel id="recruiter-type-select-label">Status</InputLabel>
                                    <Select
                                        name='invoice_filter'
                                        labelId="invoice_filter"
                                        id="invoice_filter"
                                        value={filters?.invoice_filter}
                                        label="Status"
                                        onChange={handleFilter}
                                    >
                                        <MenuItem value={"All"}>All</MenuItem>
                                        <MenuItem value={"Paid"}>Invoice Paid</MenuItem>
                                        <MenuItem value={"Not Paid"}>Invoice To be Paid</MenuItem>
                                    </Select>
                                </FormControl>
                            }
                        </Grid> */}
                    </Grid>
                </Box>
                {toggle === false ?
                    <>
                        <div className="invoicesection">
                            <MaterialTable
                                isLoading={isGenerateCandidateLoading}
                                columns={[
                                      {
                                            title: (
                                                <Box
                                                sx={{
                                                    position: "relative",
                                                    display: "flex",
                                                    alignItems: "center",
                                                }}
                                                >
                                                <Tooltip
                                                    title={`Invoice can be generated for one ${isGroupOrgFlowTrueText.toLocaleLowerCase()} at a time.`}
                                                    arrow
                                                    placement="bottom-end"
                                                >
                                                    <InfoOutlinedIcon
                                                    sx={{
                                                        position: "absolute",
                                                        left: -44,
                                                        top: "50%",
                                                        transform: "translateY(-50%)",
                                                        fontSize: 22,
                                                        cursor: "pointer"
                                                    }}
                                                    />
                                                </Tooltip>

                                                Candidate Name
                                                </Box>
                                            ),
                                            cellStyle: { padding: "10px", textAlign: "left" },
                                            headerStyle: { padding: "10px", textAlign: "left" },
                                            field: "candidate_name",
                                            editable: "never",
                                        },
                                        {
                                            title: "MPR ID",
                                            cellStyle: { padding: "10px", textAlign: "left" },
                                            headerStyle: { padding: "10px", textAlign: "left" },
                                            field: "mpr_no",
                                            editable: "never",
                                        },
                                        {
                                            title: isGroupOrgFlowTrue ? "Group Org" : "Client Name",
                                            ccellStyle: { padding: "10px", textAlign: "left" },
                                            headerStyle: { padding: "10px", textAlign: "left" },
                                            field: "company",
                                            editable: "never",
                                        },
                                        {
                                            title: "Position",
                                            cellStyle: { padding: "10px", textAlign: "left" },
                                            headerStyle: { padding: "10px", textAlign: "left" },
                                            field: "job_title",
                                            editable: "never",
                                        },
                                        {
                                            title: "Joined Date",
                                            cellStyle: { padding: "10px", textAlign: "left" },
                                            headerStyle: { padding: "10px", textAlign: "left" },
                                            field: "joined_date",
                                            editable: "never",
                                            render: (rowData) => {
                                            return rowData?.joined_date ? ConvertDate(rowData?.joined_date) : "    ";
                                            },
                                        },
                                        {
                                            title: "Joined CTC",
                                            cellStyle: { padding: "10px 17px 10px 10px", textAlign: "center" },
                                            headerStyle: { padding: "10px", textAlign: "center" },
                                            field: "joined_ctc",
                                            editable: "never",
                                        },
                                        {
                                            title: "Billable CTC",
                                            className: "billable",
                                            cellStyle: { padding: "10px", textAlign: "center", minWidth: 180 },
                                            headerStyle: { padding: "10px", textAlign: "center", minWidth: 180 },
                                            field: "billable_ctc",
                                            validate: (rowData) =>
                                            rowData?.code === "" || rowData?.code === undefined
                                                ? "Com % cannot be empty"
                                                : "",
                                            editable: isEditable,
                                        },
                                        {
                                            title: "Professional Fee % ( > 0)",
                                            cellStyle: { padding: "10px", textAlign: "center" },
                                            headerStyle: { padding: "10px", textAlign: "center" },
                                            field: "commission_percentage",
                                            validate: (rowData) =>
                                            rowData?.com === "" || rowData?.com === undefined
                                                ? "Com % cannot be empty"
                                                : "",
                                            editable: isEditable,
                                        },
                                ]}
                                data={generateCandidate || []}
                                cellEditable={{
                                    onCellEditApproved: (newValue, oldValue, rowData, columnDef) => {
                                        return new Promise((resolve, reject) => {
                                            handleCellEdit(newValue, rowData, columnDef)
                                            setTimeout(resolve, 200);
                                        });
                                    }
                                }}
                                options={{
                                    maxBodyHeight: "calc(100vh - 285px)",
                                    minBodyHeight: "calc(100vh - 285px)",
                                    rowStyle: { fontSize: "13px" },
                                    sorting: true,
                                    search: false,
                                    searchFieldAlignment: "right",
                                    searchAutoFocus: true,
                                    searchFieldVariant: "standard",
                                    filtering: false,
                                    paging: true,
                                    pageSizeOptions: [25, 50],
                                    pageSize: 25,
                                    selection: true,
                                    showTextRowsSelected: true,
                                    selectionProps: rowData => ({
                                         disabled:
                                            (selectedCompanyId &&
                                            selectedCompanyId !==
                                                (rowData?.ats_company_id || rowData?.ats_grouporg_id)) ||
                                            [null, '', 0, '0'].includes(rowData.commission_percentage),
                                    }),
                                    
                                    showSelectAllCheckbox: false,
                                    actionsColumnIndex: -1,
                                    grouping: false,
                                    addRowPosition: "first",

                                }}
                                 onSelectionChange={handleSelectionChange}
                                actions={[
                                    {
                                        icon: () => (
                                            <CustomToggle
                                                isChecked={toggle}
                                                handleToggleChange={handleToggle}
                                                Yestext={'Generated'}
                                                NoText={'Generate'}
                                                style={{ height: '32px', padding: '0px', width: '150px', labelPadding: '2px' }}
                                            />
                                        ),
                                        position: "row",
                                        isFreeAction: true,
                                        tooltip: "Toggle to view generated invoice",
                                    },
                                    {
                                        icon: () => (
                                            <Button
                                                component="span"
                                                variant="contained"
                                                className="mpl-primary-btn"
                                                onClick={hadleGenerateClick}
                                            >
                                                Generate Proforma
                                            </Button>
                                        ),
                                        isFreeAction: false,
                                        tooltip: "Generate Proforma",
                                        position: "toolbarOnSelect",
                                        hidden: selectedCandidates?.length === 0,
                                    },
                                ]}
                                title={
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <Typography variant="h6" style={{ fontWeight: "bold" }}>
                                            Generate Invoice
                                        </Typography>
                                        <Tooltip title="Only candidates in Joined stage of a job can be invoiced">
                                            <IconButton size="small" style={{ padding: 4 }}>
                                                <InfoOutlinedIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                }
                            />
                        </div>
                    </>
                    : <>
                        <MaterialTable
                            onRowClick={(event, rowData) => handleGeneratedRowClick(event, rowData)}
                            isLoading={isInvoiceLoading}
                            columns={[
                                { title: isGroupOrgFlowTrue ? "Group Org" : "Client", cellStyle: { padding: "5px 10px 5px 13px" }, field: "company" },
                                { title: "Invoice No", cellStyle: { padding: "5px 10px 5px 13px" }, field: "ats_invoice_no" },
                                {
                                    title: "Invoice Date", cellStyle: { padding: "5px 10px 5px 13px" }, field: "invoice_date",
                                    render: rowData => { return ConvertDate(rowData?.invoice_date) }
                                },
                                { title: "Invoice Amount", cellStyle: { padding: "5px 10px 5px 13px" }, field: "gst_breakup", render: (rowData) => Number(rowData?.gst_breakup?.candidate_total) || "0" },
                                { title: "GST Total", cellStyle: { padding: "5px 10px 5px 13px" }, field: "gst_total" },
                                { title: "TDS", cellStyle: { padding: "5px 10px 5px 13px" }, field: "tds_amount", render: (rowData) => Number(rowData?.tds_amount) || "0" },
                                { title: "Total Amount", cellStyle: { padding: "5px 10px 5px 13px" }, field: "invoice_amount" },
                            ]}
                            data={candidateInvoiceData || []}
                            options={{
                                maxBodyHeight: "calc(100vh - 285px)",
                                minBodyHeight: "calc(100vh - 285px)",
                                rowStyle: { fontSize: "13px" },
                                headerStyle: { padding: "0px 10px"},
                                sorting: true,
                                search: false,
                                searchFieldAlignment: "right",
                                searchAutoFocus: true,
                                searchFieldVariant: "standard",
                                filtering: false,
                                paging: true,
                                pageSizeOptions: [25, 50],
                                pageSize: 25,
                                selection: false,
                                actionsColumnIndex: -1,
                                actionsCellStyle: -1,
                                grouping: false,
                                addRowPosition: "first",
                            }}
                            title="Generated Invoice"
                            actions={[
                                {
                                    icon: () => <MoreVertIcon sx={{ color: "#637381" }}/>,
                                    position: "row",
                                    tooltip: "More",
                                    onClick: (_event, rowData) => handleMoreVertIconClick(_event, rowData)
                                },
                                {
                                    icon: () => (
                                        <CustomToggle
                                            isChecked={toggle}
                                            handleToggleChange={handleToggleoff}
                                            Yestext={'Generated'}
                                            NoText={'Generate'}
                                            style={{ height: '32px', padding: '0px', width: '150px', labelPadding: '2px' }}
                                        />
                                    ),
                                    position: "row",
                                    isFreeAction: true,
                                    tooltip: "Toggle to view generate invoice",
                                },

                            ]}
                        />

                        <Menu
                            id="more-options-menu"
                            anchorEl={anchorEl}
                            open={anchorEl}
                            onClose={handleMoreVertIconClose}
                            MenuListProps={{
                                'aria-labelledby': 'more-options-button',
                            }}
                        >
                            {isCandidateLoading ?
                                <MenuItem key="load" sx={{ display: "flex", justifyContent: "center", minWidth: "180px" }}>
                                    <CircularProgress color="primary" />
                                </MenuItem> :
                                <>
                                    <MenuItem key="download" onClick={() => handleEdit(currentData)}>
                                        <ListItemIcon> <SaveAltIcon fontSize="small" /></ListItemIcon>
                                        <ListItemText>
                                            <CSVLink style={{ color: "black" }} data={invoiceCandidateData} headers={headers} filename={currentData?.ats_invoice_no}>
                                                Download CSV
                                            </CSVLink>
                                        </ListItemText>
                                    </MenuItem>
                                    <MenuItem key="download pdf" onClick={handleDownloadPdf} disabled={pdfLoading}>
                                        <ListItemIcon>
                                            {pdfLoading ? (
                                                <CircularProgress size={18} disableShrink/>
                                            ) : (
                                                <SaveAltIcon fontSize="small" />
                                            )}
                                        </ListItemIcon>
                                        <ListItemText>
                                            {pdfLoading ? "Generating..." : "Download PDF"}
                                        </ListItemText>
                                    </MenuItem>
                                    <MenuItem key="sendmail" onClick={handleSendMail}>
                                        <ListItemIcon> <SendIcon fontSize="small" /></ListItemIcon>
                                        <ListItemText>Send Mail</ListItemText>
                                    </MenuItem>
                                    <Tooltip title={handleDisabled("invoice_generated_invoice_payment") ? "You Don't have sufficient permission. Please contact Admin." : ""}>
                                        <span>
                                            <MenuItem key="paid-action" onClick={() => handleAction("Paid")}
                                                disabled={handleDisabled("invoice_generated_invoice_payment")}
                                            >
                                                <ListItemIcon> <CreditScoreIcon fontSize="small" /></ListItemIcon>
                                                <ListItemText>Mark as Paid</ListItemText>
                                            </MenuItem>
                                        </span>
                                    </Tooltip>
                                    <Tooltip title={handleDisabled("invoice_generated_invoice_payment") ? "You Don't have sufficient permission. Please contact Admin." : ""}>
                                        <span>
                                            <MenuItem key="cancelled-action" onClick={() => {setOpenDialog(true); setAnchorEl(null);}}
                                                disabled={handleDisabled("invoice_generated_invoice_payment")}
                                            >
                                                <ListItemIcon> <CreditCardOffIcon fontSize="small" /></ListItemIcon>
                                                <ListItemText>Mark as Cancelled</ListItemText>
                                            </MenuItem>
                                        </span>
                                    </Tooltip>
                                </>
                            }


                        </Menu>
                    </>}
                <Popup
                    title={currentData?.ats_invoice_no}
                    openPopup={sendmail}
                    setOpenPopup={setSendMail}
                    maxWidth={"md"}
                    fullWidth={true}
                >
                    <AtsInvoiceMail setSendMail={setSendMail} currentData={currentData} invoiceCandidateData={invoiceCandidateData} companylogo={imageUrl} letterHeadData={letterHeadData?.[0]}/>
                </Popup>
                <ConfirmationDialog
                    title={`Cancelled Invoice ${currentData?.ats_invoice_no}`}
                    content={"Are you sure you want to proceed?"}
                    openDialog={openDialog}
                    closeDialog={setOpenDialog}
                    OkButtonText="Yes"
                    onSubmit={() => handlePaidStatus("Cancelled")}
                />
            </Box>
    )
}

export default ATSGenerateInvoice;